import { useState } from 'react';
import { ChevronDown, Shield, ShieldAlert } from 'lucide-react';
import { useTranslation } from '@solara/i18n';
import { Button, cn } from '@solara/ui-shared';
import { ROLE_LABEL, useAuth, type AdminRole } from './AuthContext';

const ROLES: AdminRole[] = ['PlatformAdmin', 'SupportAgent'];

export function RoleSwitcher() {
  const { t } = useTranslation('admin');
  const { currentUser, setRole } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => setOpen((s) => !s)}
        className="gap-2 text-xs"
        title={t('roleSwitcher.title')}
      >
        {currentUser.role === 'PlatformAdmin' ? (
          <Shield className="h-4 w-4 text-brand-600" />
        ) : (
          <ShieldAlert className="h-4 w-4 text-warning" />
        )}
        <span className="hidden sm:inline">{ROLE_LABEL[currentUser.role]}</span>
        <ChevronDown className="h-3.5 w-3.5" />
      </Button>
      {open ? (
        <div
          className="absolute end-0 mt-2 w-72 z-30 rounded-xl border border-border bg-surface shadow-lg p-2"
          onMouseLeave={() => setOpen(false)}
        >
          <div className="px-2 py-1.5 text-[11px] uppercase tracking-wider text-fg-subtle">
            {t('roleSwitcher.demo')}
          </div>
          {ROLES.map((r) => {
            const active = r === currentUser.role;
            return (
              <button
                key={r}
                type="button"
                onClick={() => {
                  setRole(r);
                  setOpen(false);
                }}
                className={cn(
                  'w-full text-start rounded-md px-3 py-2 text-sm flex items-center gap-2',
                  'transition-colors',
                  active
                    ? 'bg-brand-50 text-brand-800 font-medium'
                    : 'text-fg-muted hover:bg-surface-muted hover:text-fg',
                )}
              >
                {r === 'PlatformAdmin' ? (
                  <Shield className="h-4 w-4" />
                ) : (
                  <ShieldAlert className="h-4 w-4" />
                )}
                <span>{ROLE_LABEL[r]}</span>
              </button>
            );
          })}
          <div className="mt-1 pt-2 border-t border-border px-3 py-1.5 text-[11px] text-fg-subtle">
            {currentUser.email}
          </div>
        </div>
      ) : null}
    </div>
  );
}
